module.exports = __webpack_public_path__ + "img/slogo.356eb93b.png";